import type { AccessibilityLabelProps } from '@frontend/web-react/types/accessibility';
import { applyClass, concatClasses } from '@frontend/web-utils';
import { Link as TLink } from '@tanstack/react-router';
import type { LinkComponentProps } from '@tanstack/react-router/dist/esm/link';

export const NavLink = ({
  accessibilityLabel,
  bold = true,
  ...props
}: AccessibilityLabelProps & LinkComponentProps<'a'> & { bold?: boolean }) => {
  return (
    <TLink
      aria-label={accessibilityLabel}
      className={concatClasses(
        'text-h5 text-textPrimary hover-opacity-effect shrink-0 grow-0 underline underline-offset-4',
        applyClass(!bold, 'font-normal'),
      )}
      {...props}
    />
  );
};
